import { apiClient } from '../utils/apiClient';

const contactService = {
  submit: (payload) => apiClient.post('/contact-messages', payload).then(r => r.data),
};

export default contactService;
